import {z} from 'zod';
import dayjs from "dayjs";

const rulesCreateSchema = z.object({
    startNumbers: z.boolean({
        required_error: "Poiužití startovních čísel musí být vyplněno",
        invalid_type_error: "Poiužití startovních čísel musí být platné boolean"
    }),
    totalLapsCountForOverallResults: z.number({
        required_error: "Počet kol pro celkové výsledky musí být vyplněn",
        invalid_type_error: "Počet kol pro celkové výsledky musí být platné číslo"
    })
        .int()
        .positive({message: "Počet kol pro celkové výsledky musí být kladné číslo"}),
    categoryLapsCount: z.record(
        z.number({
            required_error: "Číslo kategorie musí být vyplněn",
            invalid_type_error: "Číslo kategorie  musí být platné číslo"
        })
            .int()
            .positive({message: "Číslo kategorie  musí být kladné číslo"}),
        z.number({
            required_error: "Počet kol pro kategorii musí být vyplněn",
            invalid_type_error: "Počet kol pro kategorii musí být platné číslo"
        })
            .int()
            .positive({message: "Počet kol pro kategorii musí být kladné číslo"}))
});

const raceCreateSchema = z.object({
    name: z.string()
        .min(3, {message: "Název kategorie musí mít alespoň 3 znaky"})
        .max(100, {message: "Název kategorie může mít maximálně 100 znaků"}),
    date: z.string()
        .refine(value => {
            return dayjs(value).isValid()
        }, {message: "Datum závodu musí být vyplněno ve formátu DD.MM.RRRR"}),
    time: z.string()
        .optional().nullable()
        .refine(value => {
            if (!value) return true;
            return dayjs(value, "HH:mm").isValid()
        }, {message: "Čas závodu musí být vyplněn ve formátu HH:MM"}),
    location: z.string()
        .max(100, {message: "Lokace závodu může mít maximálně 100 znaků"})
        .optional().nullable(),
    description: z.string()
        .max(2000, {message: "Popis závodu může mít maximálně 2000 znaků"})
        .optional()
        .nullable(),
    clubId: z.number({
        required_error: "Klub musí být vybrán",
        invalid_type_error: "Klub musí být platné číslo"
    })
        .int()
        .positive({message: "Klub musí být kladné číslo"})
        .optional().nullable(),
    rules: rulesCreateSchema
        .optional().nullable(),
    organizersIds: z.array(z.number({
        required_error: "Organizátor musí být vybrán",
        invalid_type_error: "Organizátor musí být platné číslo"
    })
        .int()
        .positive({message: "Organizátor musí být kladné číslo"}))
        .optional()
        .nullable(),
    raceSeasonId: z.number({
        required_error: "Sezóna musí být vybrána",
        invalid_type_error: "Sezóna musí být vyplněna"
    })
        .int()
        .positive({message: "Sezóna musí být kladné číslo"})
});

type RaceCreateRequest = z.infer<typeof raceCreateSchema>;
type RulesCreateRequest = z.infer<typeof rulesCreateSchema>;

export {
    raceCreateSchema,
    type RaceCreateRequest,
    rulesCreateSchema,
    type RulesCreateRequest
};